import { ca } from '@cian/analytics';

import { IProduct } from '../../../types/analytics';

export function trackCloseWarning(product: IProduct) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ct_informer',
    action: 'close',
    label: 'popup',
    products: [product],
  });
}
